import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    gethotelcleaners, saveRooster
} from "../dbconnector/connector";
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";
import EmployeeRoosterNode from '../customNodes/EmployeeRoosterNode';
import { getfilesurl, downloadfile } from '../tools/filehandler';
import Button from 'react-bootstrap/Button';
import { CgCloseR } from "react-icons/cg";
import { json } from 'react-router-dom';
import { saveFile } from "../tools/filehandler";
import ImageViewer from './ImageViewer';

const QualityControlNode = ({ rights, t, assignmentDisabled, data, events }) => {
    const [picturesarray, setPicturesarray] = useState([]);
    const [picturenameArray, setPicturenameArray] = useState([]);
    const [save, setSave] = useState(0);

    const saveassignment = () => {
        setSave(1)
        events.handleQACheck()
    }

    const onchangepicture = (e) => {
        const newFiles = Array.from(e.target.files);
        setPicturesarray(newFiles);
        const savePromises = picturesarray.map(file => saveFile(file, 3, data.id));
        Promise.all(savePromises)
            .then(results => {
                console.log('All saveFile results:', results);
                //dndCleaningAssignment(assignment)
            })
            .catch(err => console.error("Error saving pictures:", err));

    };

    useEffect(() => {
        if (data.id) {
            getfilesurl(3, data.id).then((urls) => {
                setPicturenameArray(urls);
            });
        }
    }, [data])

    useEffect(() => {
        if (save === 1 && picturesarray.length > 0 && data.id !== null) {
            const savePromises = picturesarray.map(file => saveFile(file, 3, data.id));
            Promise.all(savePromises)
                .then(results => {
                    console.log('All saveFile results:', results);
                    setSave(0);
                })
                .catch(err => console.error("Error saving pictures:", err));
        }
    }, [picturesarray, save]);

    return (
        <>
            <div id="QualityControlNode" className='assignmentdiv'>
                <div className='formcaption' onMouseDown={(e)=>events.startdrag("QualityControlNode", true,e)} onMouseUp={(e)=>events.startdrag(null, false,e)}>:::: {t('Kwaliteitscontrole')} ::::<CgCloseR className='closer' onClick={events.handleCancel} /></div>
                <div className="AssignCleaningform">
                    <label className='labelhotel'>
                        {t('Kwaliteitok')}
                    </label>
                    <input id="QAOk" name="status" className="doublegrid QAcheckbox" type='checkbox' onChange={events.QAChecked}>
                    </input>
                    <label className='labelhotel'>
                        {t('Opmerkingen')}
                    </label>
                    <textarea id="QAopmerkingen" name="QAopmerkingen" className="doublegrid" value={data.QAopmerkingen} onChange={events.handleOnchange} disabled={assignmentDisabled}>
                    </textarea>
                    <label className='labelhotel'>
                        {t('reclean')}
                    </label>
                    <input id="QARECLEAN" name="isReclean" className="doublegrid QAcheckbox" type='checkbox' onChange={events.handleOnchangeCheck} disabled={assignmentDisabled}>
                    </input>
                    <p></p>
                    <div className="taskbuttoncontainer">
                        <label htmlFor={"files" + data.id} className="small_button">{t('AddPicture')}</label>
                        <input
                            id={"files" + data.id}
                            type="file"
                            multiple
                            style={{ display: "none" }}
                            onChange={onchangepicture}
                            accept="image/*"
                        />
                    </div>
                    <ImageViewer imageArray={picturenameArray} data={data} />
                    <div id="saveDiv" className="two_Buttons doublegrid">
                        <Button type="button" id="saveButton" onClick={() => saveassignment()} className="Savebutton">{t('Save')}</Button>
                        <Button type="button" id="cancelButton" className="Savebutton" onClick={events.handleCancel} >{t('Cancel')}</Button>
                    </div>
                   
                </div>
            </div>
        </>
    );
}
export default QualityControlNode;
